const scrypt = require('./scryptSync')
scrypt.async = require('./scrypt')
module.exports = scrypt



//////////////////
// WEBPACK FOOTER
// ./~/web3-eth/~/scryptsy/lib/index.js
// module id = 1909
// module chunks = 0 1 3